module.exports = __webpack_public_path__ + "static/media/MI_Symptom_App_Screenshot.8c9036af.PNG";